import React, { useEffect, useState } from "react";
import { Button, DatePicker, Form, Tooltip } from "antd";
import dayjs from "dayjs";
import InputModalSelected from "../../../Components/InputModalSelected";
import TableAnalytic from "../Table";
import ChartSalesYTD from "../Charts/ChartSalesYTD";

import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import ExportPDF from "../utils/ExportPDF";
import ExportToExcel from "../utils/ExportToExcel";
import AddSpaceBetweenCapital from "../utils/AddSpaceBetweenCapital";
import ToRupiah from "../utils/ToRupiah";
import { GetCustomers, GetSalesYTD } from "../../../API/GetData";

const SectionSalesYTD = ({ userData, columnsCustomer }) => {
  const [formYTD] = Form.useForm();
  const [salesYTD, setSalesYTD] = useState([]);
  const [columnsSalesYTD, setColumnsSalesYTD] = useState([]);
  const [isLoadingYTD, setIsLoadingYTD] = useState(false);

  // customer state
  const [isLoadingCustomer, setIsLoadingCustomer] = useState(false);
  const [dataCustomer, setDataCustomer] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState(null);
  const [openCustomer, setOpenCustomer] = useState(false);
  const CSId = selectCustomer ? selectCustomer.CustomerId : '';


  useEffect(() => {
    const fetchCustomer = async () => {
      setIsLoadingCustomer(true);
      try {
        const res = await GetCustomers();
        setDataCustomer(res);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoadingCustomer(false);
      }
    };
    if (openCustomer) {
      fetchCustomer();
      setOpenCustomer(false);
    }
  }, [openCustomer]);

  const onFilterDataYTD = async (values) => {
    setIsLoadingYTD(true);
    try {
      // normalize CustomerName into array
      let customerData = values.CustomerName;
      if (customerData && !Array.isArray(customerData)) {
        customerData = [customerData];
      }
      const CustomerId = customerData
        ? customerData.map((i) => i.CustomerId).join(",")
        : "";

      const queryDate = values.Date.format("YYYY-MM-DD");

      let res = await GetSalesYTD(CSId, queryDate);
      if (userData.Role === "User") {
        res = res.filter((i) => i.CustomerId === userData.CustomerId);
      } else if (CustomerId) {
        res = res.filter((i) => CustomerId.includes(i.CustomerId));
      }
      setSalesYTD(res);

      if (res.length > 0) {
        const cols = Object.keys(res[0])
          .filter((k) => k !== "AccountId" && k !== "CustomerId")
          .map((k) => ({
            title: AddSpaceBetweenCapital(k),
            dataIndex: k,
            key: k,
            render: (val) =>
              typeof val === "number" && k !== "Year" ? ToRupiah(val) : val,
          }));
        setColumnsSalesYTD(cols);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingYTD(false);
    }
  };

  // set default CustomerName di form jika sudah terpilih
  useEffect(() => {
    if (selectCustomer) {
      formYTD.setFieldsValue({
        CustomerName: selectCustomer?.CustomerName,
      });
    }
  }, [formYTD, selectCustomer]);

  const onResetFilter = () => {
    formYTD.resetFields();
    setSalesYTD([]);
  };

  return (
    <div className="bg-white p-4 rounded-md mb-5">
      {/* Header & Export */}
      <div className="flex items-center gap-2 mb-2">
        <h1 className="text-xl font-bold">SALES YTD</h1>
        <div className="flex items-center">
          <Tooltip title="Export ke PDF">
            <Button
              icon={<FilePdfOutlined />}
              type="text"
              onClick={() => ExportPDF(salesYTD, columnsSalesYTD, "Sales YTD")}
            />
          </Tooltip>
          <Tooltip title="Export ke Excel">
            <Button
              icon={<FileExcelOutlined />}
              type="text"
              onClick={() => ExportToExcel(salesYTD, "Sales YTD")}
            />
          </Tooltip>
        </div>
      </div>

      {/* Filter Form */}
      <div className="flex flex-col gap-4 mb-5">
        <Form
          form={formYTD}
          layout="vertical"
          onFinish={onFilterDataYTD}
          autoComplete="off"
          initialValues={{
            Date: dayjs(), // default ke hari ini
          }}
          className="border-0 p-4"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {userData?.Role === "Admin" && (
              <InputModalSelected
                title="CUSTOMER"
                label="Customer"
                name="CustomerName"
                dataSource={dataCustomer}
                loading={isLoadingCustomer}
                columns={columnsCustomer}
                onData={(v) => setSelectCustomer(v)}
                onOpenModal={() => setOpenCustomer(true)}
                onRequired
              />
            )}
            <Form.Item label="Date" name="Date" className="w-full">
              <DatePicker className="w-full" />
            </Form.Item>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            <Button htmlType="button" onClick={onResetFilter}>
              Cancel
            </Button>
          </div>
        </Form>
      </div>

      {/* Table & Chart */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="w-full">
          <TableAnalytic
            columns={columnsSalesYTD}
            dataSource={salesYTD}
            isLoading={isLoadingYTD}
          />
        </div>
        <div className="w-full">
          <ChartSalesYTD dataSource={salesYTD} />
        </div>
      </div>
    </div>
  );
};

export default SectionSalesYTD;
